<div #componentHost class="included-content"></div>
